window.$ = $ = jQuery;

window.addEventListener('DOMContentLoaded', () => {

	const accountLoyalty = document.getElementById('account-loyalty');

	if (document.body.classList.contains('woocommerce-account') && accountLoyalty) {
		const updateMessage = document.getElementById('skinclub-updated');
		const updateMessageClose = document.getElementById('skinclub-updated-close');

		if (updateMessage && updateMessageClose) {
			updateMessageClose.addEventListener('click', function (e) {
				updateMessage.style.display = "none"
			});
		}

		const saveSettings = document.querySelector('.acf-button');
		const acfForm = document.getElementById('acf-form');
		if (saveSettings) {
			saveSettings.disabled = true;
		}

		acfForm.addEventListener('change', e => {
			if (saveSettings.hasAttribute("disabled")) {
				saveSettings.disabled = false;
			}
		});
	}
});